import {
  Component,
  ChangeDetectionStrategy,
  inject,
  DestroyRef,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { COPYRIGHT } from '../../../share/utils/constans/copyright';
import { SharelockCommonModule } from '../../../share/modules/sharelock-common.module';
import { ENavigationUnitComponentSelection } from '../../model/navigation.model';
import { NavigationService } from '../../services/navigation.service';
import { FOOTER_CONTACT_DATA } from './footer.data';
import { TranslateService } from '@ngx-translate/core';
import { getLanguageAwareExternalUrl } from '../../../share/utils/external-url.utils';

@Component({
  selector: 'shrl-footer',
  imports: [SharelockCommonModule, RouterLink, MatIconModule],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  readonly #destroyRef = inject(DestroyRef);
  readonly #navigationService = inject(NavigationService);
  readonly #translate = inject(TranslateService);

  readonly COPYRIGHT = COPYRIGHT;
  readonly FOOTER_CONTACT_DATA = FOOTER_CONTACT_DATA;

  getExternalUrl(externalUrl: string): string {
    return getLanguageAwareExternalUrl(externalUrl, this.#translate);
  }

  readonly navigationUnits$ = this.#navigationService
    .getFilterednavigationUnits$({
      componentSelection: ENavigationUnitComponentSelection.FOOTER,
      hasLabel: true,
      flatten: true,
    })
    .pipe(takeUntilDestroyed(this.#destroyRef));
}
